import React, { useState, useRef, useEffect } from 'react'
import { AppProperties } from '../common/functions';
import { Card, CardActions, CardText, TextField, Button, FontIcon, CardTitle, TabsContainer, Tabs, Tab } from 'react-md';
import logo from '../images/png/SF-Logo.png';
import QMlogo from '../images/png/EQM.png';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { BeatLoader } from 'react-spinners';

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100vh',
        padding: '1em'
    },
    loginPanel: {
        maxWidth: '25%',
        minWidth: '350px',
    },
    univName: {
        fontSize: '3rem',
        textAlign: 'center',
        fontWeight: 'bold',
        margin: '0rem',
        padding: '1.5rem 0rem'
    },
    imageContainer: {
        padding: '0.5em'
    },
    image: {
        maxWidth: '100%'
    },
    underline: { textDecoration: 'underline' }
}


const CodeForm = (props) => {
    const history = useHistory();
    const location = useLocation();
    const [mailWhiteList,setMailWhiteList] = useState([]);

    console.debug("location.pathname.substring(1)", location.pathname.substring(1))
    const appProperties = AppProperties();

    const codeRef = useRef(null);
    const emailRef = useRef(null);
    const [emailError,setEmailError] = useState(false);
    const mailDomains = appProperties.mailDomain.split(";");
    const mailIDError = `Enter a valid ${mailDomains.length > 1 ? mailDomains.join(' or ') : mailDomains} id`;
    const [showError, setShowError] = useState(false);
    const {whitelist} = props;
    const [loading, setLoading] = useState(false);

    const clearAllNotifications = () => {
        NotificationManager.listNotify.forEach(n => {
            NotificationManager.remove({ id: n.id })
        });
    }

    
    useEffect(() => {
        clearAllNotifications();
    }, [])

    const isValid = () => {
        setEmailError(false);
        // check if email is valid
        if (emailRef.current.value.length <= 0) {
            emailRef.current.focus();
            return false;
        } else {
            let domainName = ((emailRef.current.value).toLowerCase()).split("@");
            //let domainName =  emailRegex.exec((emailRef.current.value).toLowerCase());

            if (!(domainName.length > 1) || !((domainName[0].trim()).length > 1) || (!domainName || !mailDomains.includes(domainName[1])) && whitelist && (!whitelist.includes((emailRef.current.value).toLowerCase()))) {
                setEmailError(true);
                emailRef.current.focus();
                return false;
            }
        }

        // check code is valid
        if (codeRef?.current?.value.length !== 6) return false;

        return true;
    }

    const handleCodeSubmit = () => {
        setLoading(true);
        clearAllNotifications();
        setShowError(false);
        console.debug("codeRef.current.value;", codeRef.current.value)
        let code = codeRef.current.value;
        let emailID = emailRef.current.value;
        code.trim();

        if (!isValid()) {
            setShowError(true);
            return;
        }
        // if (code.length < 6) {
        //     setShowError(true);
        // }

        const response = props.apiService({
            method: 'post',
            skipErrorHandle: false,
            url: '/verifyCode',
            data: {
                code,
                emailID,
                type: location.pathname.substring(1)
            }
        });
        response.then(res => {
            console.debug("res", res);
            if (res && res.data) {
                const data = res.data;
                if (data?.status === 1) { // Verification failed
                    NotificationManager.error(data.message, 'ERROR', 5000);
                } else { // Success
                    if (location.pathname.includes('activation-code')) {+
                        NotificationManager.success("Your account has been activated.\n\nYou'll be logged in shortly", 'SUCCESS', 2000);

                    // history.push('/')
                    // Login the user with the token
                    history.push(`/profile?token=${data.data}`);
                    

                    } else {
                        history.push(`/change-password/${data.data}`)
                    }


                }

            }
            setLoading(false);
        })
    }


    return <div style={styles.container}>
        <Card style={styles.loginPanel}>
            <div className='bg-color-primary' style={styles.imageContainer}>
                {appProperties.eqmMode ?
                    <img style={styles.image} alt="EQM" title="EQuizMaster" src={QMlogo} />
                    :
                    <>
                        <img style={styles.image} alt="Stem Fluency" title="Stem Fluency" src={logo} />
                    </>
                }
            </div>
            {/* <CardTitle subtitle='Two Factor Authentication'></CardTitle> */}
            {loading ? <BeatLoader color='#bb0000' loading={true} size={10} /> : 
                <div>
                {/* <TabsContainer colored className='mt-2'>
                    <Tabs>
                        <Tab label="one">
                            <div>one</div>
                        </Tab>
                        <Tab label="two">
                            <div>Hello</div>
                        </Tab>
                    </Tabs>
                </TabsContainer> */}
                <CardTitle>{location.pathname.substring(1) === "activation-code" ? "Activation Code": "Password Reset Code"}</CardTitle>
                <CardText>

                <div className='my-2'>
                    <TextField autoComplete='email' id='email' inputStyle={{
                        fontSize: "1rem"
                    }} className='px-2 pb-4' ref={emailRef} 
                    errorText={emailError ? mailIDError : ''}
                    error={emailError}
                    // label="Email ID"
                    aria-required="true"
                    aria-describedby="email-format"
                    required leftIcon={<FontIcon className='m-0'>email</FontIcon>} placeholder='Enter your university email address'></TextField>
                </div>

                <div className='border mt-4 d-flex justify-content-center rounded-lg text-center'>
                    <TextField
                        ref={codeRef}
                        onChange={() => setShowError(false)}
                        inputClassName='text-center'
                        inputStyle={{
                            fontSize: "20px",
                            letterSpacing: "1.5rem"
                        }}
                        autoComplete={false}
                        error={showError}
                        errorText={"Please enter a valid code"}
                        id='twofa_code'
                        placeholder='CODE'
                    />
                </div>
            </CardText>
            <CardActions>
                <Button style={styles.underline} className="md-cell--right" primary onClick={()=>{
                    history.push('/request-code')
                }}>Request code?</Button>
            </CardActions>
            <CardActions>
                <Button style={styles.underline} className="md-cell--left" flat primary onClick={() => {
                    history.push('/')
                }}>Cancel</Button>
                <Button className="md-cell--right" primary raised onClick={() => {
                    handleCodeSubmit()
                }}>Submit</Button>
            </CardActions>
                </div>
            }
        </Card>
        <NotificationContainer />
    </div>
}

export default CodeForm